/* eslint-disable default-case */
import produce from 'immer';
import { listRegions, retrieveRegion, setRegion } from './actions';

const initialState = {
  loading: false,
  error: null,
  items: [],
  item: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case listRegions.TRIGGER:
    case retrieveRegion.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case listRegions.SUCCESS:
      draft.items = payload;
      break;
    case retrieveRegion.SUCCESS:
      draft.item = payload;
      break;
    case listRegions.FAILURE:
    case retrieveRegion.FAILURE:
      draft.error = payload;
      break;
    case listRegions.FULFILL:
    case retrieveRegion.FULFILL:
      draft.loading = false;
      break;

    case setRegion.toString():
      draft.item = payload;
      break;
    // no default
  }
}, initialState);

export default reducer;
